
import Flickity from 'flickity';

const flickityClass = 'f-carousel';
const baseClass = 'label-carousel';
const cellClass = `${ baseClass }__cell`;
const slideClass = `${ baseClass }__slide`;


const LabelCarousels = (() =>
{
	const c = {
		instances: [],
		cellsPerSlide: 1,
	}

	c.init = function ()
	{
		const uninstantiated = Array.from(document.querySelectorAll(`.${ flickityClass }.${ baseClass }`));
		if (!uninstantiated.length)
		{
			return;
		}

		c.cellsPerSlide = calcCellsPerSlide();

		uninstantiated.forEach(root =>
		{
			const instance = c.initCarousel(root);
			if (instance)
			{
				c.instances.push(instance);
			}
		});


		window.addEventListener('load', c.resizeInstances, { once: true });
		window.addEventListener('DOMContentLoaded', c.resizeInstances, { once: true });

		//TODO: debounce this
		window.addEventListener('resize', c.handleWindowResize);
	}


	c.initCarousel = function (root)
	{
		const slides = Array.from(document.querySelectorAll(`.${ cellClass }`));

		const hasMultipleSlides = slides.length > 1;

		const { autoPlay, draggable } = calcAutoplayAndDraggable();

		const config = {
			//cellSelector: `.${ slideClass }`,
			groupCells: false,
			pageDots: false,
			accessibility: true,
			prevNextButtons: false,
			cellAlign: 'left',
			contain: false,
			adaptiveHeight: false,
			autoPlay: hasMultipleSlides ? autoPlay : false,
			draggable: hasMultipleSlides ? draggable : false,
			wrapAround: true,
			on: {
				staticClick: function (e)
				{
					// re-enable swup for this link by the time it's event
					// is received by jquery
					if (e.target.hasAttribute('data-no-swup'))
					{
						e.target.removeAttribute('data-no-swup');
					}
				},
			},
		}

		const instance = new Flickity(root, config);

		return instance;
	}

	c.handleWindowResize = function (e)
	{
		const newCellsPerSlide = calcCellsPerSlide();
		if (newCellsPerSlide !== c.cellsPerSlide)
		{
			c.refreshInstances();
		}

		const { autoPlay, draggable } = calcAutoplayAndDraggable();
		c.instances.forEach(instance => {
			instance.options.autoPlay = autoPlay;
			instance.options.draggable = draggable;
			instance.updateOptions(); 
		});
	}

	c.refreshInstances = function ()
	{
		c.cellsPerSlide = calcCellsPerSlide();

		c.instances = c.instances.map(oldInstance =>
		{
			const rootElem = oldInstance.element;
			oldInstance.destroy();

			const newInstance = c.initCarousel(rootElem);

			return newInstance;
		})
			.filter(instance => !!instance);
	}

	c.resizeInstances = function ()
	{
		c.instances.forEach(instance =>
		{
			instance.resize();
		})
	}
	
	return c;
})();

function calcCellsPerSlide()
{
	const queries = [
		{ query: '(max-width: 680px)', cells: 1 },
		{ query: '(max-width: 1200px)', cells: 1 },
	];

	for (let i = 0; i < queries.length; i++)
	{
		const { query, cells } = queries[i];
		if (window.matchMedia(query).matches)
		{
			return cells;
		}
	}

	return 1; // largest
}

function calcAutoplayAndDraggable() {
	const queries = [
		{ query: '(max-width: 680px)', autoPlay: true, draggable: true },
		{ query: '(max-width: 1200px)', autoPlay: true, draggable: true },
		{ query: '(min-width: 1400px)', autoPlay: false, draggable: false },
	];

	for (let i = 0; i < queries.length; i++) {
		const { query, autoPlay, draggable } = queries[i];
		if (window.matchMedia(query).matches) {
			return { autoPlay, draggable };
		}
	}

	return { autoPlay: true, draggable: true }; // default values
}


export default LabelCarousels;



// WEBPACK FOOTER //
// ./scripts/modules/label-carousel.js